import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import LoginModal from "../modals/LoginModal/LoginModal";
import SignUpModal from "../modals/SignUpModal/SignUpModal";

function ProtectedRouter({ element: Element }) {

  const [loginModal, setLoginModal] = useState(true);
  const [signUpModal, setSignUpModal] = useState(false);

  const location = useLocation();
  const path = location.pathname;
  const isAuthenticated = useSelector((state) => state.authReducer.isLogin);
  return <>{isAuthenticated ? 
    Element :
    <> 
    {loginModal && (
      <LoginModal
        show={loginModal}
        setShow={setLoginModal}
        showSignUp={setSignUpModal}
      />
    )}
    {signUpModal && (
      <SignUpModal
        show={signUpModal}
        setShow={setSignUpModal}
        showLogin={setLoginModal}
      />
    )}
    </>  
    }</>;
}
export default ProtectedRouter;
